<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("sales_item_list") }}</h4>
        </div>
      </div>
    </div>

    <ThemeDataTable
      ref="salesTable"
      table-id="SalesListTable"
      :fetch-data="fetchSalesPage"
      :filters="tableFilters"
      default-order-dir="desc"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("sale_voucher_no") }}</th>
            <th>{{ $t("sale_voucher_date") }}</th>
            <th class="no-sort">{{ $t("item_name") }}</th>
            <th>{{ $t("category") }}</th>
            <th>{{ $t("sub_category") }}</th>
            <th>{{ $t("warehouse") }}</th>
            <th>{{ $t("supplier") }}</th>
            <th>{{ $t("batch") }}</th>
            <th>{{ $t("discount") }}</th>
            <th>{{ $t("vat") }}</th>
            <th>{{ $t("unit_price") }}</th>
            <th>{{ $t("sale_qty") }}</th>
            <th>{{ $t("total_sale_amount") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ret in rows" :key="ret.id || `${ret.sale_voucher}-${ret.batch_id}`">
            <td>{{ ret.sale_voucher }}</td>
            <td>{{ ret.sale_voucher_date }}</td>
            <td>
              <div class="d-flex align-items-center">
                <span class="avatar avatar-md me-2">
                  <img
                    v-if="ret.image"
                    :src="$getImageUrl(ret.image)"
                    alt="Item Image"
                  />
                  <span
                    v-else
                    class="avatar-title rounded bg-light text-secondary d-flex align-items-center justify-content-center w-100 h-100"
                  >
                    <i class="ti ti-photo"></i>
                  </span>
                </span>
                <div class="d-flex flex-column">
                  <span>{{ ret.item_name }}</span>
                  <small
                    v-if="ret.serial_number"
                    class="text-muted"
                  >
                    {{ $t('serial_number') }}: {{ ret.serial_number }}
                  </small>
                </div>
              </div>
            </td>
            <td>{{ ret.category }}</td>
            <td>{{ ret.sub_category }}</td>
            <td>{{ ret.warehouse }}</td>
            <td>{{ ret.supplier }}</td>
            <td>{{ ret.batch_id }}</td>
            <td>{{ ret.discount }}</td>
            <td>{{ ret.vat }}</td>
            <td>{{ ret.unit_price }}</td>
            <td>{{ ret.sale_qty }}</td>
            <td>{{ ret.total_sale_price }}</td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>
  </div>
</template>

<script>
import apiUrls from '@/urls';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';

export default {
  components: {
    ThemeDataTable,
  },
  data() {
    return {
      filterOptions: {
        category: [],
        warehouse: [],
      },
    };
  },
  computed: {
    tableFilters() {
      return [
        {
          key: 'category',
          label: this.$t('category'),
          options: this.filterOptions.category,
        },
        {
          key: 'warehouse',
          label: this.$t('warehouse'),
          options: this.filterOptions.warehouse,
        },
      ];
    },
  },
  methods: {
    async fetchFilterOptions() {
      try {
        const [categoriesRes, warehousesRes] = await Promise.all([
          this.$axios.get(apiUrls.categories.get),
          this.$axios.get(apiUrls.inventory_warehouse.get),
        ]);
        this.filterOptions.category = (categoriesRes?.data || [])
          .map((c) => c.node || c.name)
          .filter(Boolean);
        this.filterOptions.warehouse = (warehousesRes?.data || [])
          .map((w) => w.name)
          .filter(Boolean);
      } catch (error) {
        console.error('Error fetching sales filter options:', error);
      }
    },

    async fetchSalesPage({ draw, start, length, search, orderColumn, orderDir, filters }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
        ...filters,
      };

      const response = await this.$axios.get(apiUrls.sales_list.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },
  },
  created() {
    this.fetchFilterOptions();
  },
};
</script>
